<template>
  <main class="py-8 justify-center justify-items-center text-center text-black">
    <section class="grid gap-4">
      <!-- KYC Animation -->
      <div class="w-auto h-64">
        <Vue3Lottie :animationData="KYCAnimation" :speed="1" :loop="true" />
      </div>
      <div class="grid gap-1">
        <p class="heading-text">
          Quick Digital KYC
        </p>
        <p class="text-base text-textSecondary font-blogger px-4">
          Just enter your Aadhaar, registered mobile, and 6-digit Digi KYC PIN. Verification is quick, secure, and super easy.
        </p>
      </div>
    </section>
    <span class="grid pb-10"></span>
    <section class="footer flex">
      <custom-button
        v-if="flagsData?.manualKYCEnabled"
        variant="transparent"
        :loading="loading"
        @click.prevent="UploadManuallyRedirect()"
        class="w-full"
      >
        <p class="grid text-base">
          Upload Manually
        </p>
      </custom-button>
      <custom-button
        variant="primary"
        @click.prevent="getDigilockerUrl"
        class="w-full"
      >
        <p class="grid text-base">
          Start Digital KYC
        </p>
      </custom-button>
    </section>
    <!-- Spin Loader -->
    <spin-loader :spinLoading="isSpinLoading"/>
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import CustomButton from '../components/CustomButton.vue';
import KYCAnimation from '../assets/animation/Digital-KYC-Animation.json';
import SpinLoader from '../components/spinLoader.vue';

export default {
  name: 'KycSelection',
  components: {
    CustomButton,
    SpinLoader
  },
  computed: {
    ...mapGetters(['applicationId', 'flagsData']),
  },
  data() {
    return {
      loading: undefined,
      KYCAnimation,
      pageVisible: undefined,
      isSpinLoading: undefined,
      queryParams: this.$route.query
    };
  },
  mounted() {
    this.init();
  },
  beforeUnmount() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    init() {
      this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_KYC_PAGE_LANDED);
    },
    getDigilockerUrl() {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_START_DIGI_KYC_CLICKED);
      this.isSpinLoading = true;
      this.$store.dispatch('signzyDigiLockerUrl', {
        urlParams: {
          statusChangeRequired: false
        },
      }
      ).then((result) => {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_START_DIGI_KYC_URL, {
          [this.$mixpanelPayload.RESPONSE]: result?.url,
        });
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        if (result?.url) {
          window.microapps.openUrl({ url: result.url }); // microapps.openUrl
          this.isSpinLoading = false;
        }
      })
      .catch((err) => {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_START_DIGI_KYC_URL, {
          [this.$mixpanelPayload.ERROR_REASON]: err.message,
        });
        this.isSpinLoading = false;
      });
    },
    handleVisibilityChange() {
      if (document.hidden) {
        this.pageVisible = false;
      } else {
        this.getDigilockerStatus();
        this.pageVisible = true;
      }
    },
    getDigilockerStatus() {
      this.$store
        .dispatch('signzyDigilockerStatus', {
          applicationId: this.applicationId,
          urlParams: {
            statusChangeRequired: false
          },
        })
        .then((result) => {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_START_DIGI_KYC_STATUS, {
            [this.$mixpanelPayload.CONSENT_STATUS]: result.success,
            [this.$mixpanelPayload.SUB_STATUS]: result.subStatus
          });
          if (result.success) {
            this.$router.push({ name: 'Loan Agreement',
              query: {
                loanId: this.queryParams?.loanId,
                isAgreementSigned: this.queryParams?.isAgreementSigned,
                isMandate: this.queryParams?.isMandate,
                isBnplFlow: this.queryParams?.isBnplFlow
              }
            });
          }
        })
        .catch((err) => {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_START_DIGI_KYC_STATUS, {
            [this.$mixpanelPayload.ERROR_REASON]: err.message,
          });
        });
    },
    UploadManuallyRedirect() {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_UPLOAD_MANUALLY_CLICKED);
      this.$router.push({ name: 'Pre Approval Step 2' });
    }
  },
};
</script>
<style lang="scss" scoped>
</style>
